<script setup lang="ts">
export type SegmentedOption<T extends string> = {
  label?: string
  value: T
  icon?: string
}

defineProps<{
  options: SegmentedOption<string>[]
  modelValue: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<template>
  <div class="inline-flex rounded-md border border-default overflow-hidden">
    <button
      v-for="option in options"
      :key="option.value"
      :class="[
        'px-3 py-1 text-sm font-medium transition-colors',
        modelValue === option.value
          ? 'bg-muted text-foreground'
          : 'bg-default text-muted hover:bg-muted/50',
      ]"
      @click="emit('update:modelValue', option.value)"
    >
      <UIcon v-if="option.icon" :name="option.icon" />
      <span v-if="option.label">{{ option.label }}</span>
    </button>
  </div>
</template>
